import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Box } from '@spothero/ui';
import { UpcomingEvents } from '../../landing/UpcomingEventsLanding';
import { NotGoingToEvent } from '../../not-going-to-event/NotGoingToEvent';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchComponentEventView, setSearchComponentIsOpen, } from 'store/search/search-actions';
import useIsMobile from 'hooks/use-is-mobile';
import { useAddHideEventModal } from 'utils/url/add-hide-event-modal/add-hide-event-modal';
export const EventsPopup = () => {
    const eventView = useSelector((state) => state.search.data.searchComponentEventView);
    const modalOpen = useSelector((state) => state.search.data.eventsPopupOpen);
    const showByButton = eventView === 'selectWFilter';
    const destinationTitle = useSelector((state) => state.destination.data.title);
    const dispatch = useDispatch();
    const isMobile = useIsMobile('mobileXL');
    const addHideEventModal = useAddHideEventModal();
    const handleHide = () => {
        dispatch(setSearchComponentEventView(null));
        dispatch(setSearchComponentIsOpen(false));
        addHideEventModal(); // Add hide event modal to query params
    };
    if (isMobile) {
        return <div data-testid="desktop-events-popup-hidden"/>;
    }
    return (<Modal hasHeader isOpen={showByButton || modalOpen} onClose={handleHide} contentStyling={{
            minHeight: 'unset',
            maxHeight: '65vh',
            minWidth: '24rem',
            maxWidth: '42vw',
            marginTop: { base: 'auto', tablet: '16' },
            marginBottom: { base: 'auto', tablet: '16' },
            marginLeft: { base: '4', tablet: 'auto' },
            marginRight: { base: '4', tablet: 'auto' },
        }}>
            <ModalHeader data-testid="EventsPopup-header" sx={{
            width: 'calc(100% - 50px)', // leave space for the [x] button
        }}>
                Find parking for events near {destinationTitle}
            </ModalHeader>
            <ModalBody data-testid="EventsPopup-body" flexDirection={{ base: 'column', tablet: 'row' }}>
                <Box flex={{
            tablet: '1 1 80%',
            desktop: '1 1 65%',
            desktopXL: '1 1 50%',
        }} display="grid" gridTemplateRows="min-content">
                    <UpcomingEvents showBookParkingButton/>
                </Box>
            </ModalBody>
            <ModalFooter>
                <NotGoingToEvent />
            </ModalFooter>
        </Modal>);
};
